import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { TypeDropdownContentFilterFields } from 'contentful-types'

import DropdownContentFilter from './DropdownContentFilter'

const ContentfulDropdownContentFilter = withContentful<TypeDropdownContentFilterFields>(DropdownContentFilter)

export default ContentfulDropdownContentFilter
